import { app, Component } from 'apprun';
import CompanyList from './company-list';
import LocationList from './location-list';
import TeamList from './team-list';
import UserList from './user-list';
import GoogleDeleteList from './google-delete-list';
import SettingsComponent from './settings';
import OnboardingComponent from './onboarding';
import User from './user';
import { auth } from './api';
import { getLookup } from './utils';

import Company from './company';
import CompanyNew from './company-new';
import Location from './location';
import LocationNew from './location-new';
import UserNew from './user-new';

const Panel = ({ id, title, Comp, state }) => <div class="panel">
  <div class="x_panel">
    <div class="x_title">
      <h2>{title}</h2>
      <ul class="nav navbar-right panel_toolbox">
        <li>
          <a
            class="close-link"
            href="#"
            onclick={(e) => {
              e.preventDefault();
              app.run('#clear-panel', id);
            }}>
            <i class="fa fa-close" />
          </a>
        </li>
      </ul>
      <div class="clearfix" />
    </div>
    <div class="x_content">{Comp && <Comp id={id} state={state} />}</div>
  </div>
</div>;

export default class ManageCompanyComponent extends Component {
  state = {
    panels: {},
  };

  view = (state) => {
    const panels = Object.keys(state.panels).map(key => state.panels[key]);
    return (
      <div class="panel-container">
        {panels.map(p => (
          <Panel id={p.id} title={p.title} Comp={p.Component} state={p.state} />
        ))}
      </div>
    );
  };

  rendered = () => {
    setTimeout(() => {
      const el = document.querySelector('.panel-container');
      el?.lastElementChild?.scrollIntoView();
    });
  };

  update = {
    '#': () => {
      if (!auth.current()) {
        window.location.href = '/#login';
        return;
      }
      app.run('#company-list');
    },

    '#company-list': () => {
      app.run('#add-panel', { id: 'Company-List', title: 'RLP Companies', Component: CompanyList, level: 1 });
    },

    '#company': (_, companyId, title) => {
      app.run('#add-panel', {
        id: companyId ? 'company' : 'compNew',
        title,
        Component: companyId ? Company : CompanyNew,
        level: 2,
        state: { companyId, caller: this }
      });
    },

    '#location-list': (_, companyId) => {
      app.run('#add-panel', {
        id: 'location-list',
        title: 'Locations',
        Component: LocationList,
        level: 1,
        state: { companyId },
      });
    },

    '#location': (_, locationId, locationName, companyId) => {
      app.run('#add-panel', {
        id: locationId ? 'location' : 'locationNew',
        title: locationName,
        Component: locationId ? Location : LocationNew,
        state: { locationId, companyId },
        level: 2
      });
    },

    '#user-list': (_, companyId, locationId) => {
      app.run('#add-panel', {
        id: 'user-List',
        title: 'Users',
        Component: UserList,
        level: 1,
        state: { companyId, locationId },
      });
    },

    '#user-new': () => {
      app.run('#add-panel', {
        id: 'userNew',
        title: 'user [NEW]',
        Component: UserNew,
        level: 2,
        state: { caller: this }
      });
    },

    '#onboarding': () => {
      app.run('#add-panel', {
        id: 'onboarding',
        title: 'Onboarding',
        Component: OnboardingComponent,
        level: 1,
        state: {},
      });
    },

    '#settings': () => {
      app.run('#add-panel', { id: 'settings', title: 'Settings', Component: SettingsComponent, level: 1, state: {} });
    },

    '#google-delete-list': () => {
      app.run('#add-panel', {
        id: 'google-delete-list',
        title: 'Google Delete',
        Component: GoogleDeleteList,
        level: 1,
        state: {},
      });
    },

    '#user': (_, personId, name) => {
      if (!personId) {return;}
      app.run('#add-panel', { id: 'user-' + personId, title: name, Component: User, state: { personId }, level: 2 });
    },

    '#team-list': (_, companyId) => {
      app.run('#add-panel', {
        id: 'team-list',
        title: 'Teams',
        Component: TeamList,
        level: 1,
        state: { companyId },
      });
    },

    '#add-panel': (state, panel) => {
      for (const p in state.panels) {
        if (state.panels[p].level >= panel.level) {
          delete state.panels[p];
        }
      }
      state.panels[panel.id] = panel;
      return state;
    },
    '#clear-panel': (state, id) => {
      delete state.panels[id];
      return state;
    },
  };
}

getLookup();
new ManageCompanyComponent().start('rlp-app');
